// Mixin с методами загрузки изображений, используется на страницах с картинками продуктов

import axios from "axios";

export const loadImg = {
    methods: {
        loadImages() {
            if (this.filteredItems?.length > 0) {
                const uniqueProductCodes = [...this.filteredItems.map(item => item["Код"])];
                this.fetchImages(uniqueProductCodes, this.filteredItems);
                // this.filteredItems.forEach(product => this.loadImageForProduct(product));
            }
        },

        async fetchImages(productCodes, products) {
            try {
                const config = { headers: { 'Cache-Control': 'no-cache' } };
                const response = await axios.get(`${process.env.VUE_APP_API_URL}/products/getProductImages`, {
                    params: { productCodes }, // Массив передается под именем productCodes
                    ...config
                });

                const renameKeys = obj => {
                    return {
                        'ID': obj.image_id,
                        'Ссылка': obj.image_url,
                        'Тип': obj.image_type,
                        'Товар': obj.product_code,
                        'Имя товара': obj.product_name,
                        'Страница': obj.page_id,
                        'Текст': obj.image_text
                    };
                };

                // Преобразуем полученные данные
                const imagesByProduct = {};
                for(const img of response.data) {
                    const key = img.product_code;
                    if (!imagesByProduct[key]) {
                        imagesByProduct[key] = []; // создаём новый список изображений для конкретного товара
                    }
                    imagesByProduct[key].push(renameKeys(img));
                }

                // Связываем каждое изображение с соответствующими товарами
                products.forEach(product => {
                    const productId = product['Код'];
                    const images = imagesByProduct[productId];

                    if(images) {
                        product.images = images;
                        product.imageUrl = images.find(image => image["Тип"] === 'Заглавная'); // добавляем ссылку заглавного изображения
                    } else {
                        // console.warn(`Нет изображений для продукта с кодом ${productId}`);
                    }
                });

            } catch (e) {
                console.error(e);
            }
        },
    }
}